import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ admin_key: key }),
      });

      if (!res.ok) {
        setError('Invalid admin key');
        setLoading(false);
        return;
      }

      sessionStorage.setItem('adminKey', key);
      navigate('/admin');
    } catch {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-3xl p-8 shadow-soft">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 bg-perfect-peach/10 rounded-full flex items-center justify-center">
              <Lock className="w-7 h-7 text-perfect-peach" />
            </div>
          </div>
          <h1 className="font-playfair text-2xl font-semibold text-[#2D2420] text-center mb-1" data-testid="admin-login-heading">
            Admin Access
          </h1>
          <p className="text-african-earth text-sm text-center mb-6">
            The Perfect Peach Club
          </p>

          <form onSubmit={handleLogin}>
            <label className="block text-african-earth font-medium text-sm mb-2">Admin Key</label>
            <input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              required
              placeholder="Enter admin key"
              className="w-full border border-[#E0D5D0] rounded-xl px-4 py-3 mb-4 focus:outline-none focus:ring-2 focus:ring-perfect-peach text-sm"
              data-testid="admin-key-input"
            />
            {error && <p className="text-red-500 text-sm mb-3" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-perfect-peach text-white py-3 rounded-full font-medium hover:bg-[#C57D63] transition-all duration-300 disabled:opacity-50"
              data-testid="admin-login-button"
            >
              {loading ? 'Verifying...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
